import { userConstants } from './../constants/user.constants';

const initialState = {};

export function UserSearchDefault(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.USERSEARCHDEF_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.USERSEARCHDEF_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.USERSEARCHDEF_FAILURE:
      return {
        isLoading : false
      };
    case userConstants.USERSEARCHDEF_CLEAR:
      return { ...state, res: null };
    default:
      return state
  }
}